// @flow

import 'isomorphic-fetch'
import { push } from 'react-router-redux'
import { checkHttpStatus, getApiHeaders } from './index'

export async function basicGet(
  state: Object,
  dispatch: Function,
  url: string,
  request: Function,
  success: Function,
  failure: ?Function
) {
  dispatch(request())

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeaders(state)
      })
    )
    const data = await response.json()
    dispatch(success(data))
  } catch (error) {
    if (failure) {
      dispatch(failure(error))
    }

    if (error.response.status === 404) {
      dispatch(push('/notfound'))
    }

    if (error.response.status === 500) {
      dispatch(push('/error'))
    }
  }
}

export function checkForPolicyChanges(response) {
  return response.headers.get('X-Policy-Changes')
}



// WEBPACK FOOTER //
// ./src/utils/api.js